export const getSubcategoryList = (foodMenu, categoryId) => {
  return categoryId === null || categoryId.length === 0
    ? {}
    : foodMenu.apiData[`category-${categoryId}`].subcategories;
};

/** Looks for isSelected Key within an addon/modifier group to determine the number of selected items within a group  */
export const checkNumberOfSelectedItemsInOptionsGroup = (optionsGroup) => {
  let selectedOptions = 0;
  Object.keys(optionsGroup.items).forEach((optionsKey) => {
    if (optionsGroup.items[optionsKey].isSelected) {
      selectedOptions++;
    }
  });
  return selectedOptions;
};

/** Looks for isSelected Key within an addon/modifier group to get the selected items within a group  */
export const getSelectionOptionInOptionsGroup = (optionsGroup) => {
  let selectedOptions = {};
  Object.keys(optionsGroup.items).forEach((optionsKey) => {
    if (optionsGroup.items[optionsKey].isSelected) {
      selectedOptions[optionsKey] = optionsGroup.items[optionsKey];
    }
  });
  return selectedOptions;
};

export const isOptionGroupMandatory = (optionGroup) => {
  if (parseInt(optionGroup.minQuantity) >= 1) {
    return true;
  } else {
    return false;
  }
};

export const getCategoryIdFromItemId = (itemId, orderMenu) => {
  if (!orderMenu) {
    return "";
  }
  const menuLevel = orderMenu.menuLevel;

  if (menuLevel === "twoLevels") {
    return "";
  }
  let selectedCategoryId = "";
  Object.keys(orderMenu.apiData).forEach((key) => {
    const category = orderMenu.apiData[key];
    const subcategories = category.subcategories;
    Object.keys(subcategories).forEach((subcategoryKey) => {
      const subcategory = subcategories[subcategoryKey];
      const items = subcategory.items;
      Object.keys(items).forEach((itemKey) => {
        if (items[itemKey].id === itemId) {
          selectedCategoryId = category.id;
          return;
        }
      });
    });
  });
  return selectedCategoryId;
};

export const getSubcategoryIdFromItemId = (itemId, orderMenu) => {
  if (!orderMenu) {
    return "";
  }
  const menuLevel = orderMenu.menuLevel;
  let selectedSubcategoryId = "";
  if (menuLevel === "threeLevels") {
    Object.keys(orderMenu.apiData).forEach((key) => {
      const category = orderMenu.apiData[key];
      const subcategories = category.subcategories;
      Object.keys(subcategories).forEach((subcategoryKey) => {
        const subcategory = subcategories[subcategoryKey];
        const items = subcategory.items;
        Object.keys(items).forEach((itemKey) => {
          if (items[itemKey].id === itemId) {
            selectedSubcategoryId = subcategory.id;
            return;
          }
        });
      });
    });
  } else if (menuLevel === "twoLevels") {
    Object.keys(orderMenu.apiData).forEach((key) => {
      const subcategory = orderMenu.apiData[key];
      const items = subcategory.items;
      Object.keys(items).forEach((itemKey) => {
        if (items[itemKey].id === itemId) {
          selectedSubcategoryId = subcategory.id;
          return;
        }
      });
    });
  }

  return selectedSubcategoryId;
};

export const getCategoryNameFromId = (categoryId, orderMenu, itemId) => {
  if (orderMenu === undefined || orderMenu === null) {
    return "";
  }
  if (orderMenu.apiData === undefined || orderMenu.apiData === null) {
    return "";
  }
  if (orderMenu.menuLevel === "twoLevels") {
    return "";
  }
  if (!categoryId) {
    if (itemId) {
      return getCategoryNameFromId(getCategoryIdFromItemId(itemId, orderMenu), orderMenu);
    } else {
      return "";
    }
  }

  let selectedCategoryName = "";
  Object.keys(orderMenu.apiData).forEach((key) => {
    if (key === `category-${categoryId}`) {
      const categoryName = orderMenu.apiData[key].name;
      selectedCategoryName = categoryName;
      return;
    }
  });
  return selectedCategoryName;
};

export const getSubcategoryNameFromId = (subcategoryId, orderMenu, itemId) => {
  if (orderMenu === undefined || orderMenu === null) {
    return "";
  }
  if (orderMenu.apiData === undefined || orderMenu.apiData === null) {
    return "";
  }
  if (!subcategoryId) {
    if (itemId) {
      return getSubcategoryNameFromId(getSubcategoryIdFromItemId(itemId, orderMenu), orderMenu);
    } else {
      return "";
    }
  }
  let selectedSubcategoryName = "";

  if (orderMenu.menuLevel === "twoLevels") {
    Object.keys(orderMenu.apiData).forEach((key) => {
      if (key === `subcategory-${subcategoryId}`) {
        const subcategoryName = orderMenu.apiData[key].name;
        selectedSubcategoryName = subcategoryName;
        return;
      }
    });
  } else if (orderMenu.menuLevel === "threeLevels") {
    Object.keys(orderMenu.apiData).forEach((key) => {
      const category = orderMenu.apiData[key];
      Object.keys(category.subcategories).forEach((subcategoryKey) => {
        if (subcategoryKey === `subcategory-${subcategoryId}`) {
          const subcategoryName = category.subcategories[subcategoryKey].name;
          selectedSubcategoryName = subcategoryName;
          return;
        }
      });
    });
  }

  return selectedSubcategoryName;
};
